import { Component } from '@angular/core';
import { LanguageService } from '@uigy/shared/services/language.service';
import { CapabilitiesService } from '@uigy/shared/capabilities/capabilities.service';
import { IemService } from '@uigy/shared/services/iem.service';

@Component({
    selector: 'app-unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.scss'],
    standalone: false
})
export class UnauthorizedComponent {
  private pageTexts = this.languageService.texts.unauthorized;
  public reason = this.capabilitiesService.isGrouplessUser() ? this.pageTexts.no_groups : this.pageTexts.default;
  public isEm = this.iemService.isIEM();

  constructor(
      private languageService: LanguageService,
      private capabilitiesService: CapabilitiesService,
      private iemService: IemService,
  ) {
  }
}
